import { render, staticRenderFns } from "./RejectedItem.vue?vue&type=template&id=0984b650&scoped=true&"
import script from "./RejectedItem.vue?vue&type=script&lang=js&"
export * from "./RejectedItem.vue?vue&type=script&lang=js&"
import style0 from "./RejectedItem.vue?vue&type=style&index=0&id=0984b650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984b650",
  null
  
)

export default component.exports